import React from 'react'
import AcquireWebComponent from '../framework/MaterialUI'
import { FullRow, Row, Col } from '../framework/Grid/'
import { splitNumber } from '../../utils/utility'
import { map, isEmpty } from 'lodash'
import { Link } from 'react-router-dom'

class PopularPageListSection extends AcquireWebComponent {
	redirect(e, page){
		e.preventDefault()
	}
	render(){
		const { title, subTitle, data, reportType, tier } = this.props

		if (isEmpty(data)){
			return (
				<div className="pb-10 bg-white" key={"key-" + title.replace(" ", "-")}>
					<FullRow className="no-padding-bottom no-margin-bottom">
						<div style={{fontWeight:'bold', fontSize: '16px', letterSpacing: '-0.015em' }}>{title}</div>
					</FullRow>
					<FullRow>
						<div style={{ width: '100%', minHeight: '200px', textAlign: 'center', paddingTop: '60px', color: "#CDCDCD" }}>
							<div style={{ color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' }}>No Data</div>
						</div>	
					</FullRow>
				</div>	
			)
		}else{
			return (
				<div className="pb-10 bg-white" key={"key-" + title.replace(" ", "-")}>
					<FullRow className="no-padding-bottom no-margin-bottom">
						<div style={{fontWeight:'bold', fontSize: '16px', letterSpacing: '-0.015em' }}>{title}</div>
					</FullRow>
					<Row className="black-bottom-border no-padding no-margin-bottom ml-20 mr-20 pb-5">
						<Col xs="10" sm="10" md="10" lg="10">&nbsp;</Col>
						<Col xs="2" sm="2" md="2" lg="2" className="text-right no-padding-right">{subTitle}</Col>
					</Row>
					{
						map(data, function (obj, index) {
							return (
								<Row key={"top-visits-item-" + obj.name + "-" + obj.value} style={{fontWeight:300}}
								className="black-bottom-border no-padding no-margin-bottom ml-20 mr-20 pb-5 pt-5">
									<Col xs="10" sm="10" md="10" lg="10" className="no-padding-left">
										{
											parseInt(tier, 10) < 3 ? obj.name : (<Link to={`/insights/${reportType}?p=${obj.name}`}>{obj.name}</Link>)
										}
									</Col>
									<Col xs="2" sm="2" md="2" lg="2" style={{textAlign:"right", paddingRight:'0'}}>{splitNumber(obj.value)()}</Col>
								</Row>
							)
						})
					}
				</div>
			)	
		}
	}

}
PopularPageListSection.default = {
	tier: 3
}
export default PopularPageListSection



// WEBPACK FOOTER //
// ./src/components/Insights/PopularPageList.jsx